import React from "react";
import { Card, Image } from "semantic-ui-react";
import { useSelector } from "react-redux";
import { withRouter } from "react-router";
import "./PostCard.scss";
import GenericPostCard from "./GenericPostCard";
import { 
  facebookShareStrategy, 
  twitterShareStrategy,
  instagramShareStrategy,
  linkedinShareStrategy,
  whatsappShareStrategy,
  allAppsShareStrategy,
  smsShareStrategy
} from "../utils/sharing";

const PostCard = (props) => {
  const state = useSelector((state) => state.sharer);
  const hashtags = props.hashtags;
  const regex = new RegExp("$(?:\n)", "g");
  const addSpace = !regex.test(state.campaignText);  
  
  props = JSON.parse(JSON.stringify(props));
  if(state.platform === "twitter") {
    props.strategy = twitterShareStrategy;
  } else if (state.platform === "linkedin") {
    props.strategy = linkedinShareStrategy;
  } else if (state.platform === "facebook") {
    props.strategy = facebookShareStrategy;
  } else if (state.platform === "instagram") {
    props.strategy = instagramShareStrategy;
  } else if (state.platform === "whatsapp") {
    props.strategy = whatsappShareStrategy;
  } else if (state.platform === "native") {
    props.strategy = allAppsShareStrategy;
  } else if (state.platform === "sms") {
    props.strategy = smsShareStrategy;
  }   
  Object.preventExtensions(props);

  return (
    <>
      {props.strategy ? (
        <GenericPostCard {...props} />
      ) : (
        <div className="postcard embed-postcard posts-card">
          <p>
            {state.campaignText}
            {addSpace ? <>&nbsp;</> : null}
            <span className="postcard-tags">{hashtags}</span>
          </p>

            <Card>
              <Image src={props.image} alt="Thumbnail" wrapped ui={false} className={props.isGifThubmnail ? "gif" : ""} />
              <Card.Content>
                <a
                  href={state.sharedUrl}
                  target="_blank"
                  className="postcard-link"
                  rel="noreferrer"
                >
                  <Card.Header>Click here for more info:</Card.Header>
                  <Card.Meta>app.speechifai.tech</Card.Meta>
                </a>
              </Card.Content>
            </Card>

          <div className="postcard-buttons">
            <div className={`postcard-button generic-btn`}>
              Share with <span>{state.googlePlatform}</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default withRouter(PostCard);
